// eslint-disable-next-line import/prefer-default-export
export const CLOSE_CALLBACK_VISIBILITY_TIMER = 3000;
